import { CustomerAppointment } from "./CustomerAppointment";
import { Service } from "./DepartmentsServices";
import { SubscriberExploitation } from "./SubscriberExploitation";

export class Appointment {
    holidayName?: string;
    fromTime: string;
    toTime: string;
    shortName: string;
    yomanId: number;
    saparId?: number;
    firstName: string;
    customerId: number;
    isOffDay?: boolean;
    phoneNum2: string;
    transactId?: number;
    hasComments?: boolean;
    resourceStream: string;
    statusCall?: number;
    statusQueue?: number;
    birthDay?: number;
    birthMonth?: number;
    bColor: string;
    confStatus?: number;
    allDay?: boolean;
    editable?: boolean;
    prepayStatus?: number;
    statusAppointment?: number;
    isRepeatAppointment?: boolean;
    isCustIcon?: boolean;
    isExtAppId?: boolean;
    job?: string;
    unscheduled?: boolean;
    con?: string;
    subexp: SubscriberExploitation[] = [];
    iPath?: string;
    debt?: number;
    statusVal?: number;
    offTimeType?: number;
    isManyApp?: boolean;
    isCustAdded?: boolean;
}

export class AppointmentDetails {
    imagePath?: string;
    balance?: string;
    collectDebt?: number;
    comments?:string;
}

export class AppointmentDetailsSummaryStep {
    dateVisit?: string
    madeAppointmentId?: number;
    saparId?: number;
    comments?: string;
}

export class AppointmentIn {
    dateVisitFrom: string;
    dateVisitTo: string;
    dateVisitFrom_1: string;
    dateVisitTo_1: string;
    smsSendingResult?: number;
}

export class InvalidResourceTime {
    resource?: number;
    start?: string | Date;
    end?: string | Date;
    title?: string;
    recurring?: Recurring;
}

export class Recurring {
    repeat?: string;
    weekDays?: string;
}

export class AppointmentDetailsIn {
    yomanId?: string | number;
}

export class AppointmentCopyCutDelIn {
    yomanId?: string | number;
    dateVisitFrom: string;
    dateVisitTo: string;
    resource?: number;
    action: string;
    reasonCancellation?: ReasonCancellation;
    removeAdditionalApp?: boolean;
}

export class NextSlotIn {
    startEvent: string | object | Date;
    saparId: number | string;
}

class ReasonCancellation {
    text: string;
    value: string
}

export class AppointmentData {
    id?: number | string;
    customerapp?: CustomerAppointment;
    absenceId?: number;
    subserv?: Service[] = [];
    resourceId?: string | number;
    appointorId?: number; // new field

    statusId?: number; // new field
    // eventDates?: string;
    // eventDuration?: string;
    eventDate?: string;
    start?: string | object | Date;
    end?: string | object | Date;
    maxEventEndTime?: string;
    forceCreateCustomer?: boolean;
    remark?: string;
    // firstname?: string;
    // lastname?: string;
    // pelephon?: string;
    // sex?: number;
    isMustMadeAppoinment?: boolean;
    creationDate?: Date; // new field
    creationAppointorId?: number; // new field
}

export class StatusAppointment {
    indEv?: number;
    nameEvHeb?: string;
    imagePath?: string;
}

type ArrayStatusEvent = Array<{ id: number, text: string }>;

const arrstatuses: ArrayStatusEvent = [
    { id: 1, text: 'שכפלנו את התור ללא טיפולים. להוספת טיפולים ערכו את התור' },
    { id: 2, text: 'התור נוצר בהצלחה' },
    { id: 3, text: 'שכפלנו את התור, אך שימו לב שמשך התור קטן יותר ממשך התור המקורי'},
    { id: 4, text: 'שכפלנו את התור ללא טיפולים - כי המטפל/ת הזה לא מבצע אותם' },
    { id: 5, text: 'שכפלנו את התור אבל שימו לב שהעתקנו רק את הטיפולים שמטפל זה יודע לבצע - ויש טיפול/ים שלא הועתקו' },
    { id: 6, text: 'שכפלנו, אבל העתקנו רק את הטיפולים שמטפל זה יודע לבצע. בנוסף, שימו לב שמשך התור קטן מהזמן הנדרש בקטלוג' },
    { id: 7, text: 'זמן אישי נוצר בהצלחה' },
    { id: 8, text: 'שכפלנו את האירוע, אך שימו לב שהמשך שלו קטן יותר מהמשך של האירוע המקורי' },
    { id: 9, text: 'אופס... ההדבקה לא הצליחה, שעה זו כבר נתפסה על ידי משתמש אחר' },
    { id: 10, text: 'התור הועבר בהצלחה' },
    { id: 11, text: 'אופס... ההדבקה לא הצליחה,כי אין מספיק זמן או ששעה זו כבר נתפסה על ידי משתמש אחר' },
    { id: 12, text: 'לא ניתן להעביר את התור למטפל זה היות והוא לא יודע לעשות את כל הטיפולים' },
    { id: 13, text: 'המחיקה לא הצליחה, כיוון שהתור כבר השתנה על ידי משתמש אחר' },
    { id: 14, text: 'המחיקה לא הצליחה, כיוון שארוע כבר השתנה על ידי משתמש אחר' },
    { id: 15, text: 'המחיקה לא הצליחה, כי התור כבר שולם על ידי משתמש אחר' },
    { id: 16, text: 'לא ניתן למחוק את התור כרגע כי הוא בתהליך תשלום מקדמה.נסו שוב בעוד 10 דקות' },
    { id: 17, text: 'המחיקה לא הצליחה,כי התור כבר השתנה או נמחק על ידי משתמש אחר' },
    { id: 18, text: 'שגיאה זמנית במחיקת התור, נסו שוב לאחר סגירת חלון זה' },
    { id: 19, text: 'התורים נמחקו בהצלחה' },
    { id: 20, text: 'זמן אישי נמחק בהצלחה' },
    { id: 21, text: 'התור נמחק בהצלחה' },
    { id: 22, text: 'אופס... התור לא נשמר, כי שעה זו כבר נתפסה על ידי משתמש אחר' },
    { id: 23, text: 'העריכה לא הצליחה,כיוון שהתור כבר השתנה או נמחק על ידי משתמש אחר' },
    { id: 24, text: 'העריכה לא הצליחה, כיוון שהתור כבר שולם על ידי משתמש אחר' },
    { id: 25, text: 'האירוע עודכן בהצלחה'},
    { id: 26, text: 'התור עודכן בהצלחה '},
    
    { id: 27, text: 'המחיקה לא הצליחה,כי האירוע כבר השתנה או נמחק על ידי משתמש אחר'},    
    { id: 28, text: 'ההדבקה לא הצליחה,כי האירוע כבר השתנה או נמחק על ידי משתמש אחר'},
    { id: 29, text: 'זמן אישי הועבר בהצלחה'},
    { id: 30, text: 'אופס... ההדבקה לא הצליחה,כי אין מספיק זמן או שעה זו כבר נתפסה על ידי משתמש אחר'},
    { id: 31, text: 'ההדבקה לא הצליחה, כי התור כבר שולם על ידי משתמש אחר'},
    { id: 32, text: 'העריכה לא הצליחה,כיוון שהאירוע כבר השתנה או נמחק על ידי משתמש אחר'},

];

export function getEventStatus(i: number) {
    console.log("status upgrade: " + arrstatuses.find(x => x.id === i).text);
    return arrstatuses.find(x => x.id === i).text;
}

export class CancelationReason {
    cancelReasonID?: string;
    cancelReason?: string;
}